import { render, staticRenderFns } from "./RateContainer.vue?vue&type=template&id=da8c1cca"
import script from "./RateContainer.vue?vue&type=script&lang=js"
export * from "./RateContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports